
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"129.455","height":"69"}, attrs),
              ...rest,
            },
            children.concat([_c('defs',[_c('clipPath',{attrs:{"id":"a"}},[_c('rect',{attrs:{"width":"129","height":"69","transform":"translate(1275 392)","fill":"#fff","stroke":"#707070"}})])]),_c('g',{attrs:{"transform":"translate(-948.799 -299.831)","fill":"#eceef2"}},[_c('rect',{attrs:{"width":"63.355","height":"12.213","rx":"2.29","transform":"translate(948.799 333.568)"}}),_c('rect',{attrs:{"width":"129","height":"9.16","rx":"1.527","transform":"translate(948.799 354.941)"}}),_c('g',{attrs:{"transform":"translate(255.71 -207.621)"}},[_c('path',{attrs:{"d":"M693.235 533.597c.45-.781 12.28-15.065 12.28-15.065l8.085 9.186 9.923-14.331 13.6 20.21z"}}),_c('circle',{attrs:{"cx":"4.198","cy":"4.198","r":"4.198","transform":"translate(693.089 512.183)"}})])]),_c('g',{attrs:{"transform":"translate(-1275 -410)","fill":"#f9487f"}},[_c('rect',{attrs:{"width":"16","height":"16","rx":"3","transform":"translate(1370.455 416.667)"}}),_c('rect',{attrs:{"width":"16","height":"16","rx":"3","transform":"translate(1370.455 434.667)"}}),_c('rect',{attrs:{"width":"16","height":"16","rx":"3","transform":"translate(1388.455 416.667)"}}),_c('rect',{attrs:{"width":"16","height":"16","rx":"3","transform":"translate(1388.455 434.667)"}})])])
          )
        }
      }
    